import Loadable from '../../components/loadable';
import ModalPlaceholder from '../../components/modal_placeholder';

const DisableRecurringBookingsModal = Loadable({
  loader: () => import('../../pages/calendar/disable_recurring_bookings_modal'),
  loading: ModalPlaceholder,
});

angular.module('gym').value('DisableRecurringBookingsModal', DisableRecurringBookingsModal);
